export default function Certifications() {
  const certifications = [
    {
      name: 'ISO 9001:2015',
      description: 'Quality Management System',
      icon: 'ri-award-line'
    }
  ];

  return (
    <section id="certifications" className="py-20 bg-gradient-to-br from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">
            Certifications &amp; <span className="text-blue-600">Quality</span>
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our commitment to excellence is validated through international certifications and quality standards
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h4 className="text-2xl font-semibold text-gray-900 mb-6">
              Quality Assurance You Can Trust
            </h4>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              At Suncore International, quality is not just a promise—it's our foundation. Our <strong>ISO certifications</strong> demonstrate our unwavering commitment to delivering products and services that meet the highest international standards.
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Every product in our inventory undergoes rigorous quality checks, ensuring that our clients receive only the finest industrial components that deliver reliable performance and longevity.
            </p>

            <div className="space-y-4">
              {certifications.map((cert, index) => (
                <div key={index} className="flex items-center space-x-4 p-4 bg-white rounded-lg shadow-sm">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                    <i className={`${cert.icon} text-xl text-blue-600`}></i>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900">{cert.name}</div>
                    <div className="text-gray-600">{cert.description}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="bg-white rounded-2xl shadow-xl p-8">
              <img
                src="/img/quality-control.jpg"
                alt="Quality Control Laboratory"
                className="w-full h-64 object-cover rounded-lg mb-6"
              />
              
              <div className="text-center">
                <h5 className="text-xl font-semibold text-gray-900 mb-4">
                  Quality Control Process
                </h5>
                <div className="grid grid-cols-3 gap-4 text-center">
                  <div>
                    <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-2">
                      <i className="ri-search-eye-line text-blue-600"></i>
                    </div>
                    <div className="text-sm font-medium text-gray-700">Inspection</div>
                  </div>
                  <div>
                    <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-2">
                      <i className="ri-test-tube-line text-blue-600"></i>
                    </div>
                    <div className="text-sm font-medium text-gray-700">Testing</div>
                  </div>
                  <div>
                    <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-2">
                      <i className="ri-checkbox-circle-line text-blue-600"></i>
                    </div>
                    <div className="text-sm font-medium text-gray-700">Certification</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
